import {curry} from 'ramda';

const addClass = (className, element) => {
	element.classList.add(className);
	return element;
};

export default curry(addClass);



/** WEBPACK FOOTER **
 ** ./app/scripts/util/dom/addClass.js
 **/